import React from "react";
import {connect} from "react-redux";
import {Loading} from "../../libs/loading";
import {
    Space,
    Alert,
    Button,
    Card,
    Descriptions,
    message,
    Popconfirm,
    Typography,
    Tooltip, Collapse, Switch
} from "antd";
import {DateTimeFormat} from "../shared/DateTimeFormat";
import {DateFormat} from "../shared/DateFormat";
import PlusOutlined from "@ant-design/icons/lib/icons/PlusOutlined";
import DeleteOutlined from "@ant-design/icons/lib/icons/DeleteOutlined";
import EditOutlined from "@ant-design/icons/lib/icons/EditOutlined";
import LoginOutlined from "@ant-design/icons/lib/icons/LoginOutlined";
import {
    deleteDomain,
    importSoftwareInstallation,
    loadDomainDetail, removeAdditionalPAddressFromDomain,
    uninstallSoftware,
    uninstallSSLCertificate, updateSoftware
} from "../../actions/domains";
import SSLCertificateInstallModal from "./SSLCertificateInstallModal";
import SoftwareInstallModal from "./SoftwareInstallModal";
import IPAddressModifyModal from "./IPAddressModifyModal";
import {displayErrors, normalizeEnum} from "../../libs/utils";
import {
    CloudDownloadOutlined,
    CopyOutlined,
    UsergroupAddOutlined,
    UserOutlined
} from "@ant-design/icons";
import {StatusIndicator} from "../shared/Status";
import SoftwareInfoModal from "./SoftwareInfoModal";
import HostingAccountModifyModal from "./HostingAccountModifyModal";
import AccessItem from "../permissions/AccessItem";
import {hasPermission} from "../permissions/PermissionUtils";
import AccessGate from "../permissions/AccessGate";
import {Link} from "react-router-dom";
import SoftwareMigrationModal from "./SoftwareMigrationModal";
import DomainCreateInCpanel from "./DomainCreateInCpanel";
import AddAdditionalIPAddressModal from "./AddAdditionalIPAddressModal";
import DomainHealthBox from "./DomainHealthBox";
import SoftwareCloneModal from "./SoftwareCloneModal";
import MiscDomainActions from "./MiscDomainActions";

class DomainOverview extends React.Component {
    state = {
        loadingOverview: true,
        domain: null,
        showSSLCertificateInstallModal: false,
        updatingSSLCertificate: false,
        showSoftwareInstallModal: false,
        updatingSoftware: false,
        showIPAddressModifyModal: false,
        deletingDomain: false,
        activeSoftwareInstallation: '',
        showHostingAccountModifyModal: false,
        importingSoftware: false,
        migratingSoftware: false,
        showSoftwareMigrationModal: false,
        showCreateDomainIncPanelModal: false,
        showAddIPAddressModal: false,
        showCloneSoftwareModal: false,

        core_automatic_updates: false,
        plugin_automatic_updates: false,
        theme_automatic_updates: false,
        softwareHasChanges: false,
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if(nextProps !== prevState) {
            return nextProps;
        }

        return null;
    }

    componentDidMount() {
        this.loadDomainDetail();
    }

    loadDomainDetail() {
        if(this.props.guid !== '' && this.props.guid !== null) {
            this.props.loadDomainDetail(this.props.guid, (response) => {
                let data = {
                    domain: response.data,
                    loadingOverview: false
                }

                if(response.data.software !== null) {
                    data['core_automatic_updates'] = response.data.software.core_automatic_updates;
                    data['plugin_automatic_updates'] = response.data.software.plugin_automatic_updates;
                    data['theme_automatic_updates'] = response.data.software.theme_automatic_updates;
                }

                this.setState(data);
            }, (err) => {
                if(typeof err.response !== 'undefined') {
                    displayErrors(err.response.data);
                    this.setState({ loadingOverview: false })
                }
            });
        }
    }

    uninstallSSLCertificate() {
        this.setState({ updatingSSLCertificate: true });

        this.props.uninstallSSLCertificate(this.props.guid, () => {
            this.setState({ updatingSSLCertificate: false });

            message.success('SSL certificate update successfully scheduled!');

            this.loadDomainDetail();
            this.props.reloadDomains();
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                this.setState({ updatingSSLCertificate: false });
                displayErrors(err.response.data);
            }
        });
    }

    uninstallSoftware() {
        this.setState({ updatingSoftware: true });

        this.props.uninstallSoftware(this.props.guid, () => {
            this.setState({ updatingSoftware: false });

            message.success('Software update successfully scheduled!');

            this.loadDomainDetail();
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                this.setState({ updatingSoftware: false });
                displayErrors(err.response.data);
            }
        });
    }

    deleteDomain() {
        this.setState({ deletingDomain: true });

        this.props.deleteDomain(this.props.guid, () => {

            this.props.closeOverview();
            this.props.reloadDomains();

            this.setState({ deletingDomain: false });
            message.success('Domain deletion successfully scheduled!');

        }, (err) => {
            if(typeof err.response !== 'undefined') {
                this.setState({ deletingDomain: false });
                displayErrors(err.response.data);
            }
        });
    }

    importSoftware() {
        this.setState({ importingSoftware: true });

        this.props.importSoftwareInstallation(this.props.guid, () => {
            this.setState({ importingSoftware: false });
            this.props.reloadDomains();
            this.loadDomainDetail();

            message.success('Software successfully imported!');

        }, (err) => {
            if(typeof err.response !== 'undefined') {
                this.setState({ importingSoftware: false });
                displayErrors(err.response.data);
            }
        });
    }

    downloadSoftwareBackup() {
        message.error('Not implemented, yet!');
        // TODO: Add download software backup
    }

    viewSoftwareInfo(guid) {
        this.setState({ showSoftwareInfoModal: true, activeSoftwareInstallation: guid });
    }

    loginToCpanel(guid) {
        this.props.loginTocPanel(guid);
    }

    loginToSoftware(guid) {
        this.props.loginToSoftware(guid);
    }

    cloneSoftware(guid) {
        this.setState({ showCloneSoftwareModal: true, activeSoftwareInstallation: guid });
    }

    deleteAdditionalIPAddress(guid) {
        this.props.removeAdditionalPAddressFromDomain(this.props.guid, guid, () => {
            this.props.reloadDomains();
            this.loadDomainDetail();
            message.success('Additional IP address successfully removed!');
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
            }
        });
    }

    updateSoftwareInstallation() {
        this.setState({ updatingSoftware: true });

        let data = {
            'core_automatic_updates': this.state.core_automatic_updates,
            'plugin_automatic_updates': this.state.plugin_automatic_updates,
            'theme_automatic_updates': this.state.theme_automatic_updates,
        };

        this.props.updateSoftware(this.props.guid, data, () => {
            message.success('Software installation update successfully scheduled!');
            this.loadDomainDetail();
            this.setState({ updatingSoftware: false, softwareHasChanges: false });
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
                this.setState({ updatingSoftware: false, softwareHasChanges: false });
            }
        });
    }

    render() {
        const { Text } = Typography;

        if(this.state.loadingOverview || this.state.domain === null) {
            return <div className='text-center'><Loading /></div>;
        }

        const { domain } = this.state;
        const { ip_address, ssl_certificate, software, health, metrics, whois, hosting_account } = domain;
        const { Panel } = Collapse;

        let ssl_certificate_info = <Alert type='info' showIcon message='SSL certificate not installed!' />;
        let ssl_certificate_extras = <AccessItem scopes={['can_install_ssl_certificates']}>
            <Tooltip placement='left' title='Install SSL certificate to this domain'>
                <Button size='small' icon={<PlusOutlined />} onClick={() => this.setState({ showSSLCertificateInstallModal: true })}>Install SSL Certificate</Button>
            </Tooltip>
        </AccessItem>;

        if(ssl_certificate !== null) {
            ssl_certificate_extras = <AccessItem scopes={['can_uninstall_ssl_certificates']}><Popconfirm
                onConfirm={() => this.uninstallSSLCertificate()}
                placement='topRight'
                title="Are you sure you wish to uninstall this SSL certificate?"
                okText="Uninstall"
                disabled={ssl_certificate.status !== 'ACTIVE'}
                cancelText="Cancel">
                <Tooltip placement='left' title='Uninstall SSL certificate from this domain'>
                    <Button size='small' disabled={ssl_certificate.status !== 'ACTIVE'} icon={<DeleteOutlined />} danger>Uninstall SSL Certificate</Button>
                </Tooltip>
            </Popconfirm></AccessItem>;

            ssl_certificate_info = <Descriptions bordered size='small' column={1}>
                <Descriptions.Item style={{width: '50%'}} label='Type'>{ssl_certificate.certificate_type === 'LETS_ENCRYPT' ? 'Let\'s Encrypt' : 'Custom'}</Descriptions.Item>
                <Descriptions.Item label='Created'><DateTimeFormat value={ssl_certificate.date_created} /></Descriptions.Item>
                <Descriptions.Item label='Status'><StatusIndicator el='badge' status={ssl_certificate.status} /></Descriptions.Item>
            </Descriptions>;
        }

        let software_info = <Alert type='info' showIcon message='Software is not installed!' />;

        let software_extras = <AccessItem scopes={['can_install_software']}>
            <Space>
                <Tooltip placement='left' title='Migrate software from another hosting account.'>
                    <Button size='small' disabled={this.state.migratingSoftware} icon={<CloudDownloadOutlined />} onClick={() => this.setState({ showSoftwareMigrationModal: true })}>Migrate Installation</Button>
                </Tooltip>
                <Button size='small' disabled={this.state.importingSoftware} icon={<PlusOutlined />} onClick={() => this.setState({ showSoftwareInstallModal: true })}>New Installation</Button>
                <Popconfirm
                    onConfirm={() => this.importSoftware()}
                    placement='topRight'
                    title={<span><b>Are you sure you wish to import software?</b><br />We will scan your hosting account for installation and if found,<br /> we will associate it with your domain.</span>}
                    body
                    okText="Import"
                    cancelText="Cancel">
                    <Tooltip placement='left' title='Import software manually from hosting account'>
                        <Button size='small' disabled={this.state.importingSoftware}
                                loading={this.state.importingSoftware} icon={<PlusOutlined />}> Import Software</Button>
                    </Tooltip>
                </Popconfirm>
            </Space>
        </AccessItem>;

        if(software !== null) {
            software_extras = <AccessItem scopes={['can_uninstall_software']}>
                <Popconfirm
                    onConfirm={() => this.uninstallSoftware()}
                    placement='topRight'
                    title="Are you sure you wish to uninstall software?"
                    okText="Uninstall"
                    disabled={software.status !== 'ACTIVE'}
                    cancelText="Cancel">
                    <Tooltip placement='left' title={'Uninstall ' + software.software_name}>
                        <Button size='small' disabled={software.status !== 'ACTIVE'} icon={<DeleteOutlined />} danger>Uninstall Software</Button>
                    </Tooltip>
                </Popconfirm>
            </AccessItem>;

            software_info = <Descriptions bordered size='small' column={1}>
                <Descriptions.Item style={{width: '50%'}} label='Software'>{software.software_name}</Descriptions.Item>
                <Descriptions.Item label='Installed'><DateTimeFormat value={software.date_created} /></Descriptions.Item>
                <Descriptions.Item label='Status'><StatusIndicator el='badge' status={software.status} /></Descriptions.Item>
                <Descriptions.Item label='Automatic updates'>
                    <Descriptions bordered size='small' column={1}>
                        <Descriptions.Item label='Core'>
                            <Switch size='small' checked={this.state.core_automatic_updates} disabled={software.status !== 'ACTIVE' || this.state.updatingSoftware}
                                    loading={this.state.updatingSoftware}
                                    onChange={(value) => this.setState({ core_automatic_updates: value, softwareHasChanges: true })} />
                        </Descriptions.Item>
                        <Descriptions.Item label='Plugins'>
                            <Switch size='small' checked={this.state.plugin_automatic_updates} disabled={software.status !== 'ACTIVE' || this.state.updatingSoftware}
                                    loading={this.state.updatingSoftware}
                                    onChange={(value) => this.setState({ plugin_automatic_updates: value, softwareHasChanges: true })} />
                        </Descriptions.Item>
                        <Descriptions.Item label='Theme'>
                            <Switch size='small' checked={this.state.theme_automatic_updates} disabled={software.status !== 'ACTIVE' || this.state.updatingSoftware}
                                    loading={this.state.updatingSoftware}
                                    onChange={(value) => this.setState({ theme_automatic_updates: value, softwareHasChanges: true })} />
                        </Descriptions.Item>
                    </Descriptions>
                    {this.state.softwareHasChanges ? <div style={{marginTop: '10px'}}>
                        <Button size='small' onClick={() => this.updateSoftwareInstallation()} type='primary'>Apply Updates</Button>
                        <Button size='small' onClick={() => this.setState({
                            core_automatic_updates: software.core_automatic_updates,
                            plugin_automatic_updates: software.plugin_automatic_updates,
                            theme_automatic_updates: software.theme_automatic_updates,
                            softwareHasChanges: false,
                        })}>Cancel</Button>
                    </div> : null}
                </Descriptions.Item>
                <Descriptions.Item label='Actions'>
                    <Space>
                        <Tooltip title={'Log into ' + software.software_name}>
                            <Button size='small' disabled={software.status !== 'ACTIVE' || !hasPermission(this.props.company.permissions, ['can_login_to_software'])}
                                    icon={<LoginOutlined />} onClick={() => this.loginToSoftware(this.props.guid)}>Login</Button>
                        </Tooltip>
                        <Tooltip title='View installation info'>
                            <Button size='small' disabled={software.status !== 'ACTIVE'} icon={<UserOutlined />} onClick={() => this.viewSoftwareInfo(software.guid)}>Details</Button>
                        </Tooltip>
                        <Tooltip title='Clone installation'>
                            <Button size='small' disabled={software.status !== 'ACTIVE'} icon={<CopyOutlined />} onClick={() => this.cloneSoftware(software.guid)}>Clone</Button>
                        </Tooltip>
                    </Space>
                </Descriptions.Item>
            </Descriptions>;
        }

        let health_info = <Alert type='info' showIcon message='Health not yet checked!' />;

        if(typeof health !== 'undefined' && health !== null && health.date_health_checked !== null) {
            health_info = <DomainHealthBox ip_address={ip_address} domain={domain} health={health} />
        }

        let metrics_info = <Alert type='info' showIcon message='Metrics not yet checked!' />;
        if(typeof metrics !== 'undefined' && metrics !== null && metrics.date_metrics_checked !== null) {
            metrics_info = <Descriptions bordered size='small' column={1}>
                <Descriptions.Item style={{width: '50%'}} label='Last check'>
                    <DateFormat value={metrics.date_metrics_checked} />
                </Descriptions.Item>
                <Descriptions.Item label='DA'>{metrics.da}</Descriptions.Item>
                <Descriptions.Item label='TF'>{metrics.tf}</Descriptions.Item>
            </Descriptions>;
        }

        let google_safe_browsing = '';
        if(typeof domain.google_safe_browsing !== 'undefined' && domain.google_safe_browsing !== null && domain.google_safe_browsing.status !== null) {
            google_safe_browsing = <Descriptions bordered size='small' column={1}>
                <Descriptions.Item label='Checked'><DateTimeFormat value={domain.google_safe_browsing.date_last_check}/></Descriptions.Item>
                <Descriptions.Item label='Status'><Text type="danger">{domain.google_safe_browsing.status.join(', ')}</Text></Descriptions.Item>
                <Descriptions.Item label='Expires' style={{width: '40%'}}><DateTimeFormat value={domain.google_safe_browsing.date_status_Expires}/></Descriptions.Item>
            </Descriptions>
        }

        let domain_actions_available = ['ACTIVE', 'SUSPENDED'].indexOf(domain.status) > -1;
        let delete_domain = <AccessItem scopes={['can_delete_domains']}>
            <Popconfirm
                onConfirm={() => this.deleteDomain()}
                placement='topRight'
                title="Are you sure you want to delete this domain?"
                okText="Delete"
                okType='danger'
                disabled={!domain_actions_available}
                cancelText="Cancel">
                <Tooltip placement='left' title='Delete this domain'>
                    <Button size='small' disabled={!domain_actions_available} icon={<DeleteOutlined />} danger>Delete Domain</Button>
                </Tooltip>
            </Popconfirm>
        </AccessItem>;

        let hosting_ip_address = hosting_account.ip_address;
        if(domain.hosting_account.account_type === 'CUSTOM_HOST') {
            hosting_ip_address = hosting_account.custom_host_server.ip_address;
        }

        let hosting_hostname = hosting_account.hostname;
        if(domain.hosting_account.account_type === 'CUSTOM_HOST') {
            hosting_hostname = hosting_account.custom_host_server.hostname;
        }

        let hosting_info = <AccessItem scopes={['can_view_hosting']}>
            <Descriptions bordered size='small' column={1}>
                <Descriptions.Item label='Name' style={{width: '50%'}}>{hosting_account.name}</Descriptions.Item>
                <Descriptions.Item label='Type'>{normalizeEnum(hosting_account.account_type)}</Descriptions.Item>
                {hosting_account.account_type === 'CUSTOM_HOST' ? <Descriptions.Item label='Destination type'>{normalizeEnum(hosting_account.custom_host_server.destination_type)}</Descriptions.Item> : ''}
                {hosting_account.account_type === 'CUSTOM_HOST' && hosting_account.custom_host_server.destination_type === 'HOSTNAME' ? <Descriptions.Item label='Hostname'>{hosting_hostname}</Descriptions.Item> : ''}
                {hosting_account.account_type === 'CUSTOM_HOST' && hosting_account.custom_host_server.destination_type === 'IP_ADDRESS' ? <Descriptions.Item label='IP address'>{hosting_ip_address}</Descriptions.Item> : ''}
                {hosting_account.account_type === 'SHARED_HOSTING' ? <Descriptions.Item label='Hostname'>{hosting_hostname}</Descriptions.Item> : ''}
                {hosting_account.account_type === 'SHARED_HOSTING' ? <Descriptions.Item label='IP address'>{hosting_ip_address}</Descriptions.Item> : ''}
                {hosting_account.account_type === 'SHARED_HOSTING' ? <Descriptions.Item label='Username'>{hosting_account.username}</Descriptions.Item> : ''}
                <Descriptions.Item label='Status'><StatusIndicator el='badge' status={hosting_account.status} /></Descriptions.Item>
                {hosting_account.account_type === 'SHARED_HOSTING' ?
                    <Descriptions.Item style={{width: '50% !important'}} label='Actions'>
                        <AccessItem scopes={['can_login_to_hosting_accounts']}>
                            <Tooltip title='Login to your hosting account'>
                                <Button size='small' disabled={hosting_account.status !== 'ACTIVE'} icon={<LoginOutlined />} onClick={() => this.loginToCpanel(this.props.guid)}>Login to cPanel</Button>
                            </Tooltip>
                        </AccessItem>
                        {this.props.user.panel_mode === 'ADVANCED' ? <>
                            <AccessItem scopes={['can_edit_domains']}>
                                <Tooltip title='Create domain in cPanel'>
                                    <Button size='small' disabled={hosting_account.status !== 'ACTIVE'} icon={<PlusOutlined />} onClick={() => this.setState( { showCreateDomainIncPanelModal: true })}>Create Domain in cPanel</Button>
                                </Tooltip>
                            </AccessItem>
                            <AccessItem scopes={['can_edit_domains']}>
                                <Button size='small' disabled={hosting_account.status !== 'ACTIVE'} icon={<EditOutlined />} onClick={() => this.props.history.push('/hosting/' + hosting_account.guid)}>Manage Hosting Account</Button>
                            </AccessItem>
                        </> : null}
                    </Descriptions.Item>
                : ''}
            </Descriptions>
        </AccessItem>;

        let ssl_pending_description;
        if(typeof ssl_certificate !== 'undefined' && ssl_certificate !== null && ssl_certificate.status === 'PENDING') {
            if(typeof health !== 'undefined' && health !== null && health.date_health_checked !== null) {

                let show_ssl_health_warning = false;

                if(health.resolved_ip_address && health.resolved_ip_address !== ip_address.ip_address) {
                    show_ssl_health_warning = true;
                }

                if(health.resolved_www_ip_address && health.resolved_www_ip_address !== ip_address.ip_address) {
                    show_ssl_health_warning = true;
                }

                if(show_ssl_health_warning) {
                    ssl_pending_description = <Alert
                        style={{marginBottom: '10px'}} type='warning' showIcon
                        message={'Waiting for your domain to resolve to assigned IP address (' + ip_address.ip_address + ')!'} />;
                }
            }
        }

        let additional_ip_addresses_info;
        if(domain.additional_ip_addresses.length === 0) {
            additional_ip_addresses_info = <Alert showIcon type='info' message='Click on "Add IP address" to add an additional IP address.' />;
        } else {
            additional_ip_addresses_info = <Collapse bordered accordion>
                {domain.additional_ip_addresses.map((ip_address, index) => {
                    return <Panel style={{backgroundColor: '#fff'}} header={<span>{ip_address.ip_address_type === 'DEDICATED' ? <Tooltip title='Dedicated IP address'><UserOutlined /></Tooltip> : <Tooltip title='Shared IP address'><UsergroupAddOutlined /></Tooltip>} {ip_address.ip_address} - {ip_address.city} {ip_address.country}</span>} key={index} extra={<AccessItem scopes={['can_delete_domains']}>
                            <Popconfirm
                                onConfirm={() => this.deleteAdditionalIPAddress(ip_address.guid)}
                                placement='topRight'
                                title="Are you sure you want to remove this IP address?"
                                okText="Remove IP Address"
                                okType='danger'
                                cancelText="Cancel">
                                <Tooltip title='Remove additional IP address' placement='left'>
                                    <Button size='small' icon={<DeleteOutlined />} danger />
                                </Tooltip>
                            </Popconfirm>
                        </AccessItem>
                    }>
                        <Descriptions bordered size='small' column={1}>
                            <Descriptions.Item style={{width: '50%'}} label='IP address'>{ip_address.ip_address}</Descriptions.Item>
                            <Descriptions.Item label='Type'>{normalizeEnum(ip_address.ip_address_type)}</Descriptions.Item>
                            <Descriptions.Item label='Location'>{ip_address.city + ', ' + ip_address.country}</Descriptions.Item>
                            <Descriptions.Item label='Protocol'>{ip_address.http_version === 1 ? 'HTTP/1.1' : 'HTTP/2'}</Descriptions.Item>
                            <Descriptions.Item label='Status'>
                                <StatusIndicator el='badge' status={ip_address.status} />
                            </Descriptions.Item>
                            <Descriptions.Item label='Order'><Link to={'/billing/orders/' + ip_address.order.order_id}>#{ip_address.order.order_id}</Link></Descriptions.Item>
                            <Descriptions.Item label='Renews'><DateFormat value={ip_address.order.renewal_date} /></Descriptions.Item>
                        </Descriptions>
                    </Panel>;
                })}
            </Collapse>
        }


        return(
            <AccessGate scopes={['can_view_domains']}>
                <Card bordered={false} size='small' title='Domain' extra={delete_domain} loading={this.state.deletingDomain}>
                    <Descriptions bordered size='small' layout='horizontal' column={1}>
                        <Descriptions.Item style={{width: '50%'}} label='Domain'>{domain.domain}</Descriptions.Item>
                        <Descriptions.Item label='Status'><StatusIndicator el='badge' status={domain.status} /></Descriptions.Item>
                        <Descriptions.Item label='Type'>{domain.is_subdomain ? 'Subdomain' : 'Domain'}</Descriptions.Item>
                        {!domain.is_subdomain ? <Descriptions.Item label='Whois expires'>{whois && whois.date_whois_checked !== null ? <DateFormat value={whois.whois_expires} /> : <span>Not checked, yet!</span>}</Descriptions.Item> : ''}
                    </Descriptions>
                </Card>

                <MiscDomainActions guid={domain.guid} reloadDomains={() => this.props.reloadDomains()} />

                {typeof domain.google_safe_browsing !== 'undefined' && domain.google_safe_browsing !== null && domain.google_safe_browsing.status !== null ? <Card style={{backgroundColor: '#ffe0e0'}} title="Google Safe Browsing" bordered={false} size='small'>
                    {google_safe_browsing}
                </Card>: ''}

                <Card title="SSL Certificate" loading={this.state.updatingSSLCertificate} bordered={false} size='small' extra={ssl_certificate_extras}>
                    {ssl_pending_description}
                    {ssl_certificate_info}
                </Card>
                <Card title="IP Address" bordered={false} size='small'
                      extra={this.props.user.panel_mode === 'ADVANCED' ? <AccessItem scopes={['can_edit_domains']}>
                          <Tooltip placement='left' title={'Modify domain\'s IP address'}>
                              <Button size='small' icon={<EditOutlined />} onClick={() => this.setState({ showIPAddressModifyModal: true })}>Change IP Address</Button>
                          </Tooltip>
                      </AccessItem> : null}>
                    <Descriptions bordered size='small' column={1}>
                        <Descriptions.Item style={{width: '50%'}} label='IP address'>{ip_address.ip_address}</Descriptions.Item>
                        <Descriptions.Item label='Type'>{normalizeEnum(ip_address.ip_address_type)}</Descriptions.Item>
                        <Descriptions.Item label='Location'>{ip_address.city + ', ' + ip_address.country}</Descriptions.Item>
                        <Descriptions.Item label='Protocol'>{ip_address.http_version === 1 ? 'HTTP/1.1' : 'HTTP/2'}</Descriptions.Item>
                        <Descriptions.Item label='Status'>
                            <StatusIndicator el='badge' status={ip_address.status} />
                        </Descriptions.Item>
                        <Descriptions.Item label='Order'><Link to={'/billing/orders/' + ip_address.order.order_id}>#{ip_address.order.order_id}</Link></Descriptions.Item>
                        <Descriptions.Item label='Renews'><DateFormat value={ip_address.order.renewal_date} /></Descriptions.Item>
                    </Descriptions>
                </Card>
                {this.props.user.panel_mode === 'ADVANCED' ? <Card title="Additional IP Addresses" bordered={false} size='small'
                                                                        extra={<AccessItem scopes={['can_edit_domains']}>
                                                                            <Tooltip placement='left' title={'Add additional IP address to the domain'}>
                                                                                <Button size='small' icon={<PlusOutlined />} onClick={() => this.setState({ showAddIPAddressModal: true })}>Add IP Address</Button>
                                                                            </Tooltip>
                                                                        </AccessItem>}>
                    {additional_ip_addresses_info}
                </Card> : null}
                <Card title="Hosting Account" bordered={false} size='small' extra={this.props.user.panel_mode === 'ADVANCED' ? <AccessItem scopes={['can_edit_domains']}>
                    <Button disabled={domain.status !== 'ACTIVE'} onClick={() => this.setState({ showHostingAccountModifyModal: true })} size='small' icon={<EditOutlined />}>Change Domain's Hosting Account</Button>
                </AccessItem> : null}>
                    {hosting_info}
                </Card>
                <Card hidden={domain.hosting_account.account_type === 'CUSTOM_HOST'} title="Software" bordered={false} size='small' extra={software_extras}>
                    {software_info}
                </Card>
                {!domain.is_subdomain ? <Card title="Health" bordered={false} size='small'>
                    {health_info}
                </Card>: ''}
                {!domain.is_subdomain ? <Card title="Metrics" bordered={false} size='small'>
                    {metrics_info}
                </Card>: ''}

                <SSLCertificateInstallModal
                    domain={this.props.guid}
                    domainName={domain.domain}
                    domainType={domain.is_subdomain ? 'SUBDOMAIN' : 'DOMAIN'}
                    showModal={this.state.showSSLCertificateInstallModal}
                    closeModal={() => this.setState({ showSSLCertificateInstallModal: false })}
                    loadOverview={() => this.loadDomainDetail()} />

                <SoftwareInstallModal
                    domain={this.props.guid}
                    domainName={domain.domain}
                    showModal={this.state.showSoftwareInstallModal}
                    closeModal={() => this.setState({ showSoftwareInstallModal: false })}
                    loadOverview={() => this.loadDomainDetail()} />

                <SoftwareMigrationModal
                    domain={this.props.guid}
                    domainName={domain.domain}
                    showModal={this.state.showSoftwareMigrationModal}
                    closeModal={() => this.setState({ showSoftwareMigrationModal: false }) }
                    loadOverview={() => this.loadDomainDetail()} />

                <SoftwareCloneModal
                    domain={this.props.guid}
                    showModal={this.state.showCloneSoftwareModal}
                    close={() => this.setState({ showCloneSoftwareModal: false })}
                    loadOverview={() => this.loadDomainDetail()} />

                <IPAddressModifyModal
                    domain={this.props.guid}
                    showModal={this.state.showIPAddressModifyModal}
                    closeModal={() => this.setState({ showIPAddressModifyModal: false })}
                    ipAddress={ip_address}
                    httpVersion={ip_address.http_version}
                    loadOverview={() => {
                        this.loadDomainDetail();
                        this.props.reloadDomains();
                    }} />

                <AddAdditionalIPAddressModal
                    domain={this.props.guid}
                    showModal={this.state.showAddIPAddressModal}
                    closeModal={() => this.setState({ showAddIPAddressModal: false })}
                    loadOverview={() => {
                        this.loadDomainDetail();
                        this.props.reloadDomains();
                    }} />

                <SoftwareInfoModal
                    showModal={this.state.showSoftwareInfoModal}
                    close={() => this.setState({ showSoftwareInfoModal: false, activeSoftwareInstallation: '' })}
                    domain={domain.guid} />

                <HostingAccountModifyModal
                    showModal={this.state.showHostingAccountModifyModal}
                    activeHostingAccount={this.state.domain.hosting_account.guid}
                    domain={this.props.guid}
                    loadOverview={() => this.loadDomainDetail()}
                    close={() => this.setState({ showHostingAccountModifyModal: false })} />

                <DomainCreateInCpanel
                    showModal={this.state.showCreateDomainIncPanelModal}
                    domain={this.props.guid}
                    close={() => this.setState({ showCreateDomainIncPanelModal: false })}
                    domainName={domain.domain} />
            </AccessGate>
        );
    }
}

const mapStateToProps = state => ({
    user: state.auth.user.user,
    company: state.auth.user.user.company
});


export default connect(mapStateToProps, { loadDomainDetail, uninstallSSLCertificate,
    uninstallSoftware, deleteDomain, importSoftwareInstallation, removeAdditionalPAddressFromDomain,
    updateSoftware })(DomainOverview);